// frontend/services/reports.js
import api from './api';

export const reportService = {
    getSalesReport: (params) => api.get('/reports/sales', { params }).then(res => res.data),
    
    getTaxReport: (params) => api.get('/reports/tax', { params }).then(res => res.data),
    
    getProfitLoss: (params) => api.get('/reports/profit-loss', { params }).then(res => res.data),
    
    getInventoryReport: () => api.get('/reports/inventory').then(res => res.data),
    
    getAgingReport: (params) => api.get('/reports/aging', { params }).then(res => res.data),
    
    getExpenseReport: (params) => api.get('/reports/expenses', { params }).then(res => res.data),
    
    getCashFlowReport: (params) => api.get('/reports/cash-flow', { params }).then(res => res.data),
    
    exportReport: (type, params, format) => api.get(`/reports/export/${type}`, { params, responseType: 'blob' }).then(res => res.data),
    
    scheduleReport: (data) => api.post('/reports/schedule', data).then(res => res.data),
    
    getScheduledReports: () => api.get('/reports/scheduled').then(res => res.data)
};